import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import Helper from './helper';
import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js"

import.meta.glob([
    '../img/**'
]);

import 'swiper/css/bundle';

class App {
    constructor() {
        this.init();
    }

    init() {
        this.initDatePicker();
        this.initTooltips();
        this.initMap();
        this.conditionalFields();
        this.fileUploads();
        this.formChecks();
        this.search();
        this.menu();
        this.modal();
        this.slider();
        this.cookies();
        this.honeyForms();
        this.asyncForms();
        this.wizardForms();
        this.responsiveEmbeds();
    }

    /**
     * Initialize the date picker plugin
     */
    initDatePicker (container = document) {
        // Initialize date picker
        container.querySelectorAll('.datepicker').forEach(input => {
            let defaultDate = null;

            if (input.value.length) {
                // Split the string into parts
                let dateParts = input.value.split('-');

                // Use the parts to create a Date object
                defaultDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
            }


            // Resolve date rules
            const resolveDateRule = (rule) => {
                if (!rule) return null;

                const today = new Date();

                switch (rule) {
                    case 'today':
                        return today;
                    case 'yesterday':
                        return new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
                    case 'tomorrow':
                        return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
                    case 'first_day_of_week':
                        return new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1));
                    case 'first_day_of_month':
                        return new Date(today.getFullYear(), today.getMonth(), 1);
                    case 'first_day_of_next_week':
                        return new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + (today.getDay() === 0 ? 1 : 8));
                    case 'first_day_of_next_month':
                        return new Date(today.getFullYear(), today.getMonth() + 1, 1);
                    case '7_days_ago':
                        return new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
                    case '14_days_ago':
                        return new Date(today.getFullYear(), today.getMonth(), today.getDate() - 14);
                    case '1_month_ago':
                        return new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
                    case '7_days_ahead':
                        return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
                    case '14_days_ahead':
                        return new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14);
                    case '1_month_ahead':
                        return new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
                    default:
                        return null;
                }
            };

            const defaultDateRule = input.dataset.defaultDateRule;

            if (defaultDateRule) {
                defaultDate = resolveDateRule(defaultDateRule);
            }

            let options = {
                defaultDate: defaultDate,
                dateFormat:  'd-m-Y',
                locale:      Dutch,
                allowInput:  true
            };

            const minDateRule = input.dataset.minDateRule;
            const maxDateRule = input.dataset.maxDateRule;

            if (minDateRule) {
                options.minDate = resolveDateRule(minDateRule);
            }

            if (maxDateRule) {
                options.maxDate = resolveDateRule(maxDateRule);
            }

            // Initialize flatpickr
            flatpickr(input, options);
        });
    }

    /**
     * Initialize Bootstrap tooltips
     */
    initTooltips (container = document) {
        let tooltipTriggerList = [].slice.call(container.querySelectorAll('[data-bs-toggle="tooltip"]'));

        tooltipTriggerList.map(tooltipTriggerEl => {
            return new bootstrap.Tooltip(tooltipTriggerEl, {
                trigger: 'hover'
            })
        });
    }

    initMap() {
        const mapElement = document.getElementById('map');

        if (mapElement === null) {
            return;
        }

        const map = new google.maps.Map(mapElement, {
            zoom: 7,
            scrollwheel: false,
            center: {
                lat: 52.22913,
                lng: 4.97207
            },
            styles: [
                { "featureType": "administrative.neighborhood", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "hue": "#ff0000" }] },
                { "featureType": "administrative.neighborhood", "elementType": "labels.text.fill", "stylers": [{ "visibility": "off" }] },
                { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#F1F1F0" }] },
                { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#C6CBBE" }] },
                { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#C0BCB4" }] },
                { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#C8D0DB" }] }
            ]
        });

        let currentInfoWindow = null;

        // Helper to create a marker
        const createMarker = ({ latitude, longitude, title, description, icon }) => {
            const marker = new google.maps.Marker({
                position: {
                    lat: latitude,
                    lng: longitude
                },
                icon: icon,
                map
            });

            const infoWindow = new google.maps.InfoWindow({
                content: `<span class="info-window__title">${title}</span><div class="info-window__text">${description}</div>`
            });

            const openInfoWindow = () => {
                if (currentInfoWindow) {
                    currentInfoWindow.close();
                }

                infoWindow.open({ anchor: marker, map });

                currentInfoWindow = infoWindow;
            };

            marker.addListener('mouseover', openInfoWindow);
            marker.addListener('click', openInfoWindow);
        };

        // Create all markers
        locations.forEach((location, i) => {
            setTimeout(() => createMarker(location), i * 100);
        });
    }

    fileUploads() {
        Helper.bindEventListener(document, 'change', '.form__upload input[type="file"]', function() {
            let fileName = this.closest('.form__upload').querySelector('.filename');

            // Toggle visibility
            fileName.style.display = 'inline';

            // Update contents
            fileName.innerText = this.files[0].name;
        });
    }

    formChecks() {
        Helper.bindEventListener(document, 'click', '.form-check-input[data-url]', function() {
            console.log('clicked');

            // Redirect to URL
            window.location.href = this.dataset.url;
        });
    }

    search() {
        // Bind the click event listener to the search toggle buttons to toggle the search form
        Helper.bindEventListener(document, 'click', '[data-toggle="search"]', function (e) {
            let form = e.target.closest('div').querySelector('form');

            form.classList.toggle('active');

            let isActive = form.classList.contains('active');

            // Toggle aria-expanded attribute for accessibility
            this.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
    }

    conditionalFields (container = document) {
        const elements = container.querySelectorAll('[data-conditional]');

        elements.forEach(element => {
            const conditionalName = element.dataset.conditional;

            // Skip elements with empty conditional name
            if (!conditionalName) {
                return;
            }

            const conditionalValues = element.dataset.conditionalValues.split('|');

            // Select all elements with this name (radios, checkboxes) OR a single element with that name (like a select)
            let targets = Array.from(document.querySelectorAll(`[name="${conditionalName}"]`)).filter(t => t.type !== 'hidden');

            // Fallback: also support elements that only have an ID (useful for selects)
            if (targets.length === 0) {
                const singleTarget = document.getElementById(conditionalName);

                if (singleTarget) {
                    targets = [singleTarget];
                }
            }

            const updateVisibility = () => {
                let value = '';

                const firstTarget = targets[0];
                const type = firstTarget?.type;

                if (type === 'radio') {
                    const checked = document.querySelector(`input[name="${conditionalName}"]:checked`);

                    value = checked ? checked.value : '';
                }
                else if (type === 'checkbox') {
                    if (targets.length === 1) {
                        value = firstTarget.checked ? firstTarget.value : '';
                    }
                    else {
                        value = Array.from(targets)
                            .filter(t => t.checked)
                            .map(t => t.value)
                            .join('|');
                    }
                }
                else {
                    // Covers <select>, <input type="text">, etc.
                    value = firstTarget?.value || '';
                }

                const shouldShow = conditionalValues.includes(value);

                element.style.display = shouldShow ? 'block' : 'none';

                // Toggle required attribute on hidden fields to prevent browser validation errors
                const requiredFields = element.querySelectorAll('[data-required]');

                requiredFields.forEach(field => {
                    // Find the actual form control (might be the field itself or a child element)
                    let actualField = field;
                    if (!['INPUT', 'SELECT', 'TEXTAREA'].includes(field.tagName)) {
                        const innerField = field.querySelector('input, select, textarea');
                        if (innerField) {
                            actualField = innerField;
                        }
                    }

                    if (shouldShow) {
                        field.setAttribute('required', '');
                        if (actualField !== field) {
                            actualField.setAttribute('required', '');
                        }
                    } else {
                        field.removeAttribute('required');
                        if (actualField !== field) {
                            actualField.removeAttribute('required');
                        }
                    }
                });
            };

            // Bind change listener for all
            targets.forEach(target => target.addEventListener('change', updateVisibility));

            // Run once on load
            updateVisibility();
        });
    }

    menu() {
        let toggleMenu = () => {
            document.getElementById('menu').classList.toggle('active');

            document.querySelectorAll('[data-toggle="menu"]').forEach(btn => {
                btn.classList.toggle('active');

                let isActive = btn.classList.contains('active');

                // Toggle aria-expanded attribute for accessibility
                btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            });
        }

        let closeMenu = () => {
            document.getElementById('menu').classList.remove('active');

            document.querySelectorAll('[data-toggle="menu"]').forEach(btn => {
                btn.classList.remove('active');

                // Toggle aria-expanded attribute for accessibility
                btn.setAttribute('aria-expanded', 'false');
            });
        }

        // Bind the keydown event listener to close the menu when the Escape key is pressed
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                closeMenu();
            }
        });

        // Bind the click event listener to the menu toggle buttons to toggle the menu
        Helper.bindEventListener(document, 'click', '[data-toggle="menu"]', function () {
            toggleMenu();
        });
    }

    modal() {
        const modalEl = document.getElementById('modal-info');

        if (modalEl === null) {
            return;
        }

        Helper.bindEventListener(document, 'click', '[data-toggle="modal"]', function () {
            const fieldId = this.dataset.fieldId;

            if (!fieldId) {
                return;
            }

            // Show loading state
            modalEl.querySelector('.modal__title').innerText = 'Laden...';
            modalEl.querySelector('.modal__body').innerHTML = '<p>Laden...</p>';

            // Show modal immediately
            bootstrap.Modal.getOrCreateInstance(modalEl).show();

            // Fetch modal content via AJAX
            Helper.post('/async/forms/modal-content', { field_id: fieldId })
                .then(response => {
                    modalEl.querySelector('.modal__title').innerText = response.modal_title || '';
                    modalEl.querySelector('.modal__body').innerHTML = response.modal_content || '';
                })
                .catch(error => {
                    console.error('Error fetching modal content:', error);

                    modalEl.querySelector('.modal__title').innerText = 'Fout';

                    modalEl.querySelector('.modal__body').innerHTML = '<p>Er is een fout opgetreden bij het laden van de inhoud.</p>';
                });
        });
    }

    slider() {
        document.querySelectorAll('.slider').forEach(element => {
            let paginationOptions = {}, pagination = element.closest('section').querySelector('.swiper-pagination');

            if (pagination) {
                // Create pagination
                paginationOptions = {
                    clickable 	: true,
                    type        : 'bullets',
                    el			: '#' + pagination.getAttribute('id')
                };
            }

            new Swiper('#' + element.getAttribute('id'), {
                pagination: paginationOptions,
                loop: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                autoplay: {
                    delay: 5000
                }
            });
        });
    }

    /**
     * Set cookie preferences
     */
    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    /**
     * Honey pot protection for forms
     */
    honeyForms() {
        // Initialize honey pot for a single form
        const initHoneyForm = (form) => {
            // Skip if already initialized
            if (form.dataset.honeyInitialized === 'true') {
                return;
            }

            // Mark as initialized
            form.dataset.honeyInitialized = 'true';

            // Randomize delay between 4-6 seconds to be less predictable
            const delay = 4000 + Math.random() * 2000;

            setTimeout(() => {
                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    // Restore original button text
                    const originalText = buttonSubmit.getAttribute('data-text');

                    if (originalText) {
                        buttonSubmit.innerHTML = originalText;
                        buttonSubmit.disabled = false;
                    }
                }

                let coffeeCup = form.querySelector('.coffee-cup');

                if (coffeeCup) {
                    // Fill the coffee cup
                    coffeeCup.value = 'filled';

                    // For Livewire-bound fields, trigger input event to sync with wire:model
                    if (coffeeCup.hasAttribute('wire:model') || coffeeCup.hasAttribute('wire:model.defer')) {
                        coffeeCup.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            }, delay);
        };

        // Initialize all existing honey forms
        document.querySelectorAll('.form--honey').forEach(form => {
            initHoneyForm(form);
        });

        // Watch for dynamically added forms
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    // Check if the added node is a form with honey class
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('form--honey')) {
                            initHoneyForm(node);
                        }

                        // Also check for honey forms within the added node
                        if (node.querySelectorAll) {
                            node.querySelectorAll('.form--honey').forEach(form => {
                                initHoneyForm(form);
                            });
                        }
                    }
                });
            });
        });

        // Start observing the document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    /**
     * Process asynchronous forms
     */
    asyncForms() {
        let gRecaptchaWidgets = [];

        let recaptchaReadyPromise = null;

        const getRecaptchaWidgets = () => document.querySelectorAll('.g-recaptcha-widget');

        const hasRecaptchaWidgets = () => getRecaptchaWidgets().length > 0;

        const isRecaptchaReady = () => typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.render === 'function';

        const renderRecaptchaWidgets = () => {
            if (hasRecaptchaWidgets() === false || isRecaptchaReady() === false) {
                return false;
            }

            getRecaptchaWidgets().forEach(recaptcha => {
                if (recaptcha.dataset.widgetId) {
                    return;
                }

                let widgetId = window.grecaptcha.render(recaptcha.id, {
                    'sitekey' : config.recaptcha_site_key
                });

                recaptcha.dataset.widgetId = widgetId;

                if (gRecaptchaWidgets.includes(widgetId) === false) {
                    gRecaptchaWidgets.push(widgetId);
                }
            });

            return true;
        };

        const waitForRecaptcha = () => {
            if (hasRecaptchaWidgets() === false || renderRecaptchaWidgets()) {
                return Promise.resolve();
            }

            if (recaptchaReadyPromise !== null) {
                return recaptchaReadyPromise;
            }

            recaptchaReadyPromise = new Promise(resolve => {
                let poller = null;
                let attempts = 0;
                const maxAttempts = 100;

                const cleanup = () => {
                    document.removeEventListener('recaptcha:ready', handleReady);

                    if (poller !== null) {
                        window.clearInterval(poller);
                    }

                    resolve();
                };

                const handleReady = () => {
                    renderRecaptchaWidgets();
                    cleanup();
                };

                document.addEventListener('recaptcha:ready', handleReady);

                poller = window.setInterval(() => {
                    attempts += 1;

                    if (renderRecaptchaWidgets() || attempts >= maxAttempts) {
                        cleanup();
                    }
                }, 100);
            });

            return recaptchaReadyPromise;
        };

        waitForRecaptcha();

        /**
         * Refresh reCAPTCHA
         */
        let refreshRecaptcha = () => {
            // Check if reCAPTCHA is loaded
            if (isRecaptchaReady() === false) {
                return;
            }

            // Refresh all recaptcha widget instances
            gRecaptchaWidgets.forEach(widgetId => {
                window.grecaptcha.reset(widgetId);
            });
        };

        const validateRecaptcha = (form) => {
            const recaptcha = form.querySelector('.g-recaptcha-widget');

            if (recaptcha === null) {
                return true;
            }

            renderRecaptchaWidgets();

            const error = form.querySelector('[data-recaptcha-client-error]');

            if (isRecaptchaReady() === false || recaptcha.dataset.widgetId === undefined || window.grecaptcha.getResponse(recaptcha.dataset.widgetId).length === 0) {
                if (error) {
                    error.style.display = 'block';
                }

                return false;
            }

            if (error) {
                error.style.display = 'none';
            }

            return true;
        };

        if (hasRecaptchaWidgets()) {
            setInterval(function() {
                refreshRecaptcha();
            }, 2 * 60 * 1000);
        }

        Helper.bindEventListener(document, 'submit', '.form--async', (e) => {
            e.preventDefault();

            let form = e.target;

            // For wizard forms, validate before submitting
            if (form.hasAttribute('data-wizard')) {
                const isValid = this.validateWizardForm(form);

                if (!isValid) {
                    // Scroll to first invalid field
                    const firstInvalid = form.querySelector('.is-invalid');

                    if (firstInvalid) {
                        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        firstInvalid.focus();
                    } else {
                        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }

                    return;
                }
            }

            if (validateRecaptcha(form) === false) {
                const recaptchaContainer = form.querySelector('[data-wizard-recaptcha]') || form.querySelector('.g-recaptcha-widget');

                recaptchaContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

                return;
            }

            let formMessages = form.querySelector('.form-messages');
            let spinner = form.querySelector('.spinner-border');

            // Clear the form messages
            formMessages.replaceChildren();

            if (spinner) {
                // Show the spinner icon
                spinner.style.display = 'block';
            }

            Helper.request(form.action, new FormData(form), 'json', form.method).then(response => {
                if (spinner) {
                    // Hide the spinner icon
                    spinner.style.display = 'none';
                }

                // Reset form
                form.reset();

                if (response.html) {
                    // Create a temporary container to parse the new HTML
                    const temp = document.createElement('div');
                    temp.innerHTML = response.html;
                    const newForm = temp.firstElementChild;

                    // Replace the old form with the new one
                    form.replaceWith(newForm);

                    // Re-bind conditional fields
                    this.conditionalFields(newForm);

                    // Re-initialize tooltips
                    this.initTooltips(newForm);

                    // Re-initialize wizard forms
                    this.wizardForms(newForm);

                    // Re-initialize date pickers
                    this.initDatePicker(newForm);

                    // Update formMessages reference for potential message display
                    formMessages = newForm.querySelector('.form-messages');
                }

                if (response.message) {
                    // Update form message contents
                    formMessages.innerHTML = '<div class="alert alert-success"><span>' + response.message + '</span></div>';
                }

                waitForRecaptcha().then(() => {
                    // Refresh reCAPTCHA
                    refreshRecaptcha();
                });
            })
            .catch(error => {
                // Show notification
                alert('Er is iets misgegaan.');

                waitForRecaptcha().then(() => {
                    // Refresh reCAPTCHA
                    refreshRecaptcha();
                });

                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    /**
     * Validate all visible required fields in a wizard form
     */
    validateWizardForm(form) {
        // Find the visible section by checking computed display style
        const allSections = form.querySelectorAll('[data-wizard-step]');

        let currentSection = null;

        for (const section of allSections) {
            if (section.style.display !== 'none') {
                currentSection = section;
                break;
            }
        }

        if (!currentSection) {
            return true;
        }

        // Get all fields that should be required (have data-required attribute)
        const requiredFields = currentSection.querySelectorAll('[data-required]');

        let isValid = true;

        requiredFields.forEach(field => {
            // Check if the field's conditional container is visible
            const conditionalParent = field.closest('[data-conditional]');
            const isConditionallyHidden = conditionalParent && conditionalParent.style.display === 'none';

            // Skip fields that are conditionally hidden
            if (isConditionallyHidden) {
                return;
            }

            // Handle wrapper elements (e.g., .form__select wrapping a select)
            let actualField = field;

            if (!['INPUT', 'SELECT', 'TEXTAREA'].includes(field.tagName)) {
                const innerField = field.querySelector('input, select, textarea');

                if (innerField) {
                    actualField = innerField;
                }
            }

            // Check field validity
            if (actualField.type === 'checkbox') {
                if (!actualField.checked) {
                    isValid = false;
                    actualField.classList.add('is-invalid');
                } else {
                    actualField.classList.remove('is-invalid');
                }
            } else if (actualField.type === 'radio') {
                const radioGroup = currentSection.querySelectorAll(`[name="${actualField.name}"]`);
                const isChecked = Array.from(radioGroup).some(radio => radio.checked);

                if (!isChecked) {
                    isValid = false;
                    radioGroup.forEach(radio => radio.classList.add('is-invalid'));
                } else {
                    radioGroup.forEach(radio => radio.classList.remove('is-invalid'));
                }
            } else {
                if (!actualField.value || !actualField.value.trim()) {
                    isValid = false;
                    actualField.classList.add('is-invalid');
                } else {
                    actualField.classList.remove('is-invalid');
                }
            }
        });

        return isValid;
    }

    /**
     * Handle wizard form navigation
     */
    wizardForms(container = document) {
        // Handle both container with forms inside, and direct form element
        let forms;
        if (container.matches && container.matches('form[data-wizard]')) {
            forms = [container];
        } else {
            forms = container.querySelectorAll('form[data-wizard]');
        }

        forms.forEach(form => {
            const progressSteps = form.querySelectorAll('.form__wizard-step');

            const sections = form.querySelectorAll('[data-wizard-step]');

            const prevButton = form.querySelector('[data-wizard-prev]');
            const nextButton = form.querySelector('[data-wizard-next]');
            const submitButton = form.querySelector('button[type="submit"]');
            const recaptchaContainer = form.querySelector('[data-wizard-recaptcha]');

            const hasValidationError = (element) => Array.from(element.querySelectorAll('.validation-error:not([data-recaptcha-client-error])')).some(error => error.textContent.trim().length > 0);

            const getInitialStep = () => {
                for (const [index, section] of sections.entries()) {
                    if (hasValidationError(section)) {
                        return index;
                    }
                }

                if (recaptchaContainer && hasValidationError(recaptchaContainer)) {
                    return sections.length - 1;
                }

                return 0;
            };

            let currentStep = getInitialStep();

            const updateProgress = () => {
                progressSteps.forEach((step, index) => {
                    step.classList.toggle('form__wizard-step--active', index === currentStep);
                    step.classList.toggle('form__wizard-step--completed', index < currentStep);
                });
            };

            const updateButtons = () => {
                const isFirstStep = currentStep === 0;
                const isLastStep = currentStep === sections.length - 1;

                // Show/hide previous button
                if (prevButton) {
                    prevButton.style.display = isFirstStep ? 'none' : 'inline-block';
                }

                // Show/hide next button
                if (nextButton) {
                    nextButton.style.display = isLastStep ? 'none' : 'inline-block';
                }

                // Show/hide submit button
                if (submitButton) {
                    submitButton.style.display = isLastStep ? 'inline-block' : 'none';
                }

                // Show/hide reCAPTCHA
                if (recaptchaContainer) {
                    recaptchaContainer.style.display = isLastStep ? 'block' : 'none';
                }
            };

            const showStep = (stepIndex) => {
                sections.forEach((section, index) => {
                    const isVisible = index === stepIndex;

                    section.style.display = isVisible ? 'block' : 'none';

                    // Toggle required attribute on fields in hidden/shown steps to prevent browser validation errors on hidden fields
                    const requiredFields = section.querySelectorAll('[data-required]');

                    requiredFields.forEach(field => {
                        // Only toggle if the field's parent conditional container is visible (or has no conditional)
                        const conditionalParent = field.closest('[data-conditional]');

                        const isConditionallyHidden = conditionalParent && conditionalParent.style.display === 'none';

                        // Find the actual form control (might be the field itself or a child element)
                        let actualField = field;
                        if (!['INPUT', 'SELECT', 'TEXTAREA'].includes(field.tagName)) {
                            const innerField = field.querySelector('input, select, textarea');
                            if (innerField) {
                                actualField = innerField;
                            }
                        }

                        if (isVisible && !isConditionallyHidden) {
                            // Make field required
                            field.setAttribute('required', '');
                            if (actualField !== field) {
                                actualField.setAttribute('required', '');
                            }
                        }
                        else {
                            // Remove required attribute
                            field.removeAttribute('required');
                            if (actualField !== field) {
                                actualField.removeAttribute('required');
                            }
                        }
                    });
                });

                updateProgress();
                updateButtons();
            };

            const validateCurrentStep = () => {
                const currentSection = sections[currentStep];

                // Get all fields that should be required (have data-required attribute)
                const requiredFields = currentSection.querySelectorAll('[data-required]');

                let isValid = true;

                requiredFields.forEach(field => {
                    // Check if the field's conditional container is visible
                    const conditionalParent = field.closest('[data-conditional]');

                    const isConditionallyHidden = conditionalParent && conditionalParent.style.display === 'none';

                    // Skip fields that are conditionally hidden
                    if (isConditionallyHidden) {
                        return;
                    }

                    // Handle wrapper elements (e.g., .form__select wrapping a select)
                    // If the element with data-required is not an input/select/textarea, find the actual form control inside
                    let actualField = field;

                    if (!['INPUT', 'SELECT', 'TEXTAREA'].includes(field.tagName)) {
                        const innerField = field.querySelector('input, select, textarea');

                        if (innerField) {
                            actualField = innerField;
                        }
                    }

                    // Check field validity
                    if (actualField.type === 'checkbox') {
                        if (!actualField.checked) {
                            isValid = false;

                            actualField.classList.add('is-invalid');
                        }
                        else {
                            actualField.classList.remove('is-invalid');
                        }
                    }
                    else if (actualField.type === 'radio') {
                        const radioGroup = currentSection.querySelectorAll(`[name="${actualField.name}"]`);

                        const isChecked = Array.from(radioGroup).some(radio => radio.checked);

                        if (!isChecked) {
                            isValid = false;

                            radioGroup.forEach(radio => radio.classList.add('is-invalid'));
                        }
                        else {
                            radioGroup.forEach(radio => radio.classList.remove('is-invalid'));
                        }
                    }
                    else {
                        if (!actualField.value || !actualField.value.trim()) {
                            isValid = false;
                            actualField.classList.add('is-invalid');
                        }
                        else {
                            actualField.classList.remove('is-invalid');
                        }
                    }
                });

                return isValid;
            };

            // Handle next button clicks
            Helper.bindEventListener(form, 'click', '[data-wizard-next]', (e) => {
                e.preventDefault();

                if (validateCurrentStep()) {
                    if (currentStep < sections.length - 1) {
                        currentStep++;
                        showStep(currentStep);

                        // Scroll to form top
                        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            });

            // Handle previous button clicks
            Helper.bindEventListener(form, 'click', '[data-wizard-prev]', (e) => {
                e.preventDefault();

                if (currentStep > 0) {
                    currentStep--;
                    showStep(currentStep);

                    // Scroll to form top
                    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });

            // Initialize the wizard
            showStep(currentStep);
        });
    }

    /**
     * Wrap iframes in a responsive container
     */
    responsiveEmbeds() {
        let wrap = function (toWrap, wrapper) {
            wrapper = wrapper || document.createElement('div');
            toWrap.parentNode.insertBefore(wrapper, toWrap);
            return wrapper.appendChild(toWrap);
        }

        // Responsive embeds
        document.querySelectorAll('iframe:not([class])').forEach(iframe => {
            let wrapper = document.createElement('div');

            wrapper.setAttribute('class', 'ratio ratio-16x9');

            wrap(iframe, wrapper);
        });
    }
}

window.addEventListener('load', () => new App());
